import Vue from 'vue'
import CartPopup from './CartPopup'
import bsBreakpoints from '../../../vendor/bs-breakpoints'

const elemCart = document.getElementById('cart-popup')
if (elemCart) {
  const cartPopup = new Vue(CartPopup).$mount( elemCart )

  if (!bsBreakpoints.isTabletOrMobile())
  {
    const elem = document.querySelector('.js-open-cart-popup')
    if (elem) {
      elem.addEventListener('click', (e) => {
        e.preventDefault()
        cartPopup.toggle()
      })
    }
  }
}

